import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const ImgYear18 = (props) => (
  <StaticQuery
    query={graphql`
      query {

        p1: file(relativePath: { eq: "studio/year18/1.jpg" }) {
          childImageSharp {
            fluid(quality: 50) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        p2: file(relativePath: { eq: "studio/year18/2.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          p3: file(relativePath: { eq: "studio/year18/3.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          p4: file(relativePath: { eq: "studio/year18/4.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p5: file(relativePath: { eq: "studio/year18/5.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p6: file(relativePath: { eq: "studio/year18/6.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p7: file(relativePath: { eq: "studio/year18/7.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p8: file(relativePath: { eq: "studio/year18/8.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p9: file(relativePath: { eq: "studio/year18/9.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p10: file(relativePath: { eq: "studio/year18/10.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p11: file(relativePath: { eq: "studio/year18/11.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p12: file(relativePath: { eq: "studio/year18/12.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p13: file(relativePath: { eq: "studio/year18/13.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p14: file(relativePath: { eq: "studio/year18/14.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p15: file(relativePath: { eq: "studio/year18/15.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p16: file(relativePath: { eq: "studio/year18/16.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p17: file(relativePath: { eq: "studio/year18/17.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p18: file(relativePath: { eq: "studio/year18/18.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }


          p19: file(relativePath: { eq: "studio/year18/19.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
  
          p20: file(relativePath: { eq: "studio/year18/20.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
  
            p21: file(relativePath: { eq: "studio/year18/21.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
  
            p22: file(relativePath: { eq: "studio/year18/22.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p23: file(relativePath: { eq: "studio/year18/23.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p24: file(relativePath: { eq: "studio/year18/24.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p25: file(relativePath: { eq: "studio/year18/25.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p26: file(relativePath: { eq: "studio/year18/26.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p27: file(relativePath: { eq: "studio/year18/27.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p28: file(relativePath: { eq: "studio/year18/28.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p29: file(relativePath: { eq: "studio/year18/29.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p30: file(relativePath: { eq: "studio/year18/30.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }


      }
    `}
    render={data => <Img fluid={data[props.image].childImageSharp.fluid} />}
  />
)
export default ImgYear18
